import { render, staticRenderFns } from "./importer.vue?vue&type=template&id=18c7289c&scoped=true"
import script from "./importer.vue?vue&type=script&lang=js"
export * from "./importer.vue?vue&type=script&lang=js"
import style0 from "./importer.vue?vue&type=style&index=0&id=18c7289c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7289c",
  null
  
)

export default component.exports